import { render, staticRenderFns } from "./AmseuFooterBottom.vue?vue&type=template&id=45052354&scoped=true"
import script from "./AmseuFooterBottom.vue?vue&type=script&lang=ts"
export * from "./AmseuFooterBottom.vue?vue&type=script&lang=ts"
import style0 from "./AmseuFooterBottom.vue?vue&type=style&index=0&id=45052354&prod&lang=scss&scoped=true"
import style1 from "./AmseuFooterBottom.vue?vue&type=style&index=1&id=45052354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45052354",
  null
  
)

export default component.exports